import { CheckBox, UnChecked } from "@/utils/images/CheckBoxIcon";
import { useCartData } from "@/zustand/cartStore";
import { useProductData } from "@/zustand/productStore";
import React, { useState, useEffect } from "react";

const SubscriptionBox = ({ onChange }) => {
  const isSubscribeGlobal = useCartData((state) => state.isSubscribe);
  const setIsSubscribe = useCartData((state) => state.setIsSubscribe);
  const setProductsBySubscription = useProductData((state) => state.setProductsBySubscription);
  const base = window.subscription_template;
  const [isChecked, setIsChecked] = useState(isSubscribeGlobal);

  useEffect(() => {
    setIsChecked(isSubscribeGlobal);
  }, [isSubscribeGlobal]);

  const handleToggle = () => {
    const newChecked = !isChecked;
    setIsChecked(newChecked);
    setIsSubscribe(newChecked);
    setProductsBySubscription?.(newChecked);
    if (onChange) onChange(newChecked);
  };

  return (
    <div className="subscriptionBox__subscriptionBox">
      <div
        className="subscriptionBox__checkbox"
        onClick={handleToggle}
        role="checkbox"
        tabIndex={0}
        aria-checked={isChecked}
        aria-label={base?.tr_subscription_title || "Subscription"}
      >
        {isChecked ? <CheckBox /> : <UnChecked width={16} height={16} />}
      </div>
      <div>
        <div className="subscriptionBox__title">{base?.tr_subscription_title}</div>
        <div className="subscriptionBox__description">{base?.tr_subscription_description}</div>
      </div>
    </div>
  );
};

export default SubscriptionBox;
